import { Tag } from "lucide-react";
import DefaultIcon from "../../../public/DefaultIcon.png";

export const getImageUrl = (part) => {
  if (
    part?.imageUrls &&
    Array.isArray(part?.imageUrls) &&
    part?.imageUrls.length > 0
  ) {
    return part?.imageUrls[0];
  }
  if (
    part?.imageReferences &&
    Array.isArray(part?.imageReferences) &&
    part?.imageReferences.length > 0
  ) {
    return part?.imageReferences;
  }
  if (part?.imageUrl) {
    return part?.imageUrl;
  }
  return DefaultIcon;
};

export const getDisplayPrice = (price) => {
  if (typeof price === "number") {
    return price.toFixed(2);
  }
  if (typeof price === "string" && !isNaN(parseFloat(price))) {
    return parseFloat(price).toFixed(2);
  }
  return "N/A";
};

export const getDisplayName = (item) => {
  const name =
    item?.name?.toLowerCase() === "other"
      ? `${item?.sub_name} (Other)`
      : item?.name;
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const getDisplayMakeModel = (item) => {
  if (!item) return "";

  const make = item?.make || "";
  const subMake = item?.sub_make || "";
  const model = item?.model || "";
  const subModel = item?.sub_model || "";

  const isOther =
    make?.toLowerCase() === "other" || model?.toLowerCase() === "other";

  const displayMake =
    make?.toLowerCase() === "other" && subMake ? subMake : make;
  const displayModel =
    model?.toLowerCase() === "other" && subModel ? subModel : model;

  let result = `${displayMake} ${displayModel}`.trim();

  result = result
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

  if (isOther) {
    result += " (Other)";
  }

  return result;
};

export const tierStyles = {
  featured: {
    icon: Tag,
    label: "Featured",
    bgColor: "bg-yellow-100 dark:bg-yellow-100",
    textColor: "text-yellow-700 dark:text-yellow-800",
    borderColor: "border-yellow-300 dark:border-yellow-800"
  }
};

export const getCurrentTier = (part) => {
  if (part?.isFeatured) return tierStyles.featured;
  return null;
};
